import React, { ReactNode, useEffect, useState } from 'react';
import { DataGridCellBaseProps } from '../../DataGridCell.types';
import {
  AllieChevronForward,
  AllieChevronDown,
} from '../../../../styling/icons';
import { StyledDataGridExpandedCell } from './DataGridExpandedCell.styles';

export type DataGridExpandedCellProps = {
  render?: (
    value: string | number | any,
    data: any,
    row: any,
    onlyRender?: boolean,
  ) => Promise<ReactNode>;
  position?: 'start' | 'end';
  onlyRender?: boolean;
};

export const DataGridExpandedCell: React.FC<DataGridCellBaseProps> = ({
  value,
  row,
  cellProps: { render, position = 'end', onlyRender = false },
}) => {
  const [renderValue, setRenderValue] = useState(value);
  useEffect(() => {
    if (render) {
      render(value, row.original, row)
      .then((value: any) => setRenderValue(value))
    }
  }, []);

  const defaultRender = (
    <div onClick={row.getToggleExpandedHandler()} style={{ cursor: 'pointer' }}>
      {position === 'start' && renderValue}
      {row.getCanExpand() && (
        <button
          style={{
            background: 'transparent',
            color: 'black',
          }}
        >
          {row.getIsExpanded() ? <AllieChevronDown /> : <AllieChevronForward />}
        </button>
      )}{' '}
      {position === 'end' && renderValue}
    </div>
  );

  return (
    <StyledDataGridExpandedCell row={row} onlyRender={onlyRender}>
      {onlyRender ? renderValue : defaultRender}
    </StyledDataGridExpandedCell>
  );
};
